import React from 'react';
import './ModuleOverview.css';

const ModuleOverview = () => {
    return (
        <div className='max-w-screen-xl mx-auto mt-28'>
            <h1 className=" text-3xl text-center text-primary dark:text-slate-200 font-bold">Module  <span className='text-secondary'>Overview</span></h1>


            <div className='card h-full border-3 shadow-inner mt-10   grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2'>



                <div className="card p-2">
                    <img alt="gallery" className="w-full h-full"
                        src="https://i.ibb.co/4mwmRtk/shutterstock-394793860-1024x784.jpg" />
                </div>



                <div className="card scroll-style p-2 text-primary dark:text-slate-200">


                    <h2 className=' text-[18px] font-semibold mt-3 '>Module-1 :   Welcome vedio</h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-2 :  oriantation.How to get ready  course</h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-3 :  Learn and Explore HTML a Beginer </h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-4 :  Learn and Explore HTML tag and attibute</h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-5 : Explore HTML a Flex and Grid  </h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-6 : Explore HTML a Beginer Responsive  </h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-7 : HTML Advance Explore  </h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-8 :  Explore HTML a Beginer Responsive  </h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-9 :  HTML Advance Explore </h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-10 : Oriantation.How to get ready  course</h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-11 :  Learn and Explore HTML a Beginer </h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-12 :  Learn and Explore HTML a Beginer </h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-13 :  Learn and Explore HTML a Beginer </h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-14 :  Learn and Explore HTML a Beginer </h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-15 :  Learn and Explore HTML a Beginer </h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-16 :  Learn and Explore HTML a Beginer </h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-17 :  Learn and Explore HTML a Beginer </h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-18 :  Learn and Explore HTML a Beginer </h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-19 :  Learn and Explore HTML a Beginer </h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-20 :  Learn and Explore HTML a Beginer </h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-21 :  Learn and Explore HTML a Beginer </h2>
                    <h2 className=' text-[18px] font-semibold mt-3'>Module-22 :  Learn and Explore HTML a Beginer </h2>


                </div>
            </div>
        </div>
    );
};

export default ModuleOverview;